<template>
    <div class="page">
        <section id="sidebar" :class="{ hide: !showside }" :aria-expanded="showside">
            <div class="brand">
                <img :src="url" crossorigin="anonymous" alt="شعار الشركة" />
            </div>
            <div class="search-bar">
                <input
                    type="text"
                    v-model="searchQuery"
                    placeholder="بحث في القائمة"
                    aria-label="البحث في عناصر القائمة"
                    @input="filterMenu"
                />
                <i class="bi bi-search"></i>
            </div>
            <ul class="side-menu top">
                <!-- إدارة أملاك -->
                <li class="menu-group">
                    <button @click="toggleGroup('property')" :aria-expanded="menuGroups.property" :aria-controls="'property-items'">
                        <i class="bi bi-building"></i>
                        <span>إدارة أملاك</span>
                        <i class="bi" :class="menuGroups.property ? 'bi-chevron-down' : 'bi-chevron-right'"></i>
                    </button>
                    <ul v-show="menuGroups.property && isItemVisible('property')" id="property-items" class="submenu">
                        <li>
                            <router-link to="/customerDashboard/property" :aria-current="isActive('/customerDashboard/property') ? 'page' : null">
                                <i class="bi bi-house-door"></i>
                                العقارات
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/customerDashboard/property/ownerAllpayments" :aria-current="isActive('/customerDashboard/property/ownerAllpayments') ? 'page' : null">
                                <i class="bi bi-receipt"></i>
                                سندات القبض للأملاك
                            </router-link>
                        </li>
                    </ul>
                </li>
                <!-- إدارة مشاريع -->
                <li class="menu-group">
                    <button @click="toggleGroup('project')" :aria-expanded="menuGroups.project" :aria-controls="'project-items'">
                        <i class="bi bi-briefcase"></i>
                        <span>إدارة مشاريع</span>
                        <i class="bi" :class="menuGroups.project ? 'bi-chevron-down' : 'bi-chevron-right'"></i>
                    </button>
                    <ul v-show="menuGroups.project && isItemVisible('project')" id="project-items" class="submenu">
                        <li>
                            <router-link to="/customerDashboard/project/allprojectsbills" :aria-current="isActive('/customerDashboard/project/allprojectsbills') ? 'page' : null">
                                <i class="bi bi-file-earmark-text"></i>
                                فواتير مشتريات مشاريع
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/customerDashboard/project/AllExtractsPayment" :aria-current="isActive('/customerDashboard/project/AllExtractsPayment') ? 'page' : null">
                                <i class="bi bi-file-earmark-check"></i>
                                المستخلصات
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/customerDashboard/project/CostReport" :aria-current="isActive('/customerDashboard/project/CostReport') ? 'page' : null">
                                <i class="bi bi-graph-up"></i>
                                تقارير تكلفة المشاريع
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/customerDashboard/project/CostReportDetailsClass" :aria-current="isActive('/customerDashboard/project/CostReportDetailsClass') ? 'page' : null">
                                <i class="bi bi-table"></i>
                                تقارير تكلفة المشاريع بالتبويب
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/customerDashboard/project/CostReportitems" :aria-current="isActive('/customerDashboard/project/CostReportitems') ? 'page' : null">
                                <i class="bi bi-list-ul"></i>
                                تقارير تكلفة المشاريع بالتفاصيل
                            </router-link>
                        </li>
                    </ul>
                </li>
                <!-- تقارير الضريبة -->
                <li class="menu-group">
                    <button @click="toggleGroup('tax')" :aria-expanded="menuGroups.tax" :aria-controls="'tax-items'">
                        <i class="bi bi-calculator"></i>
                        <span>تقارير الضريبة</span>
                        <i class="bi" :class="menuGroups.tax ? 'bi-chevron-down' : 'bi-chevron-right'"></i>
                    </button>
                    <ul v-show="menuGroups.tax && isItemVisible('tax')" id="tax-items" class="submenu">
                        <li>
                            <router-link to="/customerDashboard/TaxReport" :aria-current="isActive('/customerDashboard/TaxReport') ? 'page' : null">
                                <i class="bi bi-file-earmark-text"></i>
                                تقارير الضريبة
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/customerDashboard/zatca-invoices" :aria-current="isActive('/customerDashboard/zatca-invoices') ? 'page' : null">
                                <i class="bi bi-file-earmark-text"></i>
                                تقارير ضريبة هيئة الزكاة
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/customerDashboard/project/ProjectTaxReportOwner" :aria-current="isActive('/customerDashboard/project/ProjectTaxReportOwner') ? 'page' : null">
                                <i class="bi bi-cash-stack"></i>
                                ضريبة الملاك (مبيعات أو إيجارات)
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/customerDashboard/project/allOver-report-owners" :aria-current="isActive('/customerDashboard/project/allOver-report-owners') ? 'page' : null">
                                <i class="bi bi-file-earmark-bar-graph"></i>
                                تقرير ضريبة شامل
                            </router-link>
                        </li>
                    </ul>
                </li>
                <!-- كشف حساب المالك -->
                <li>
                    <router-link to="/customerDashboard/property/Customerstatement" :aria-current="isActive('/customerDashboard/property/Customerstatement') ? 'page' : null">
                        <i class="bi bi-person-lines-fill"></i>
كشف الحساب مستأجر                    </router-link>
                </li>
            </ul>
            <ul class="side-menu bottom">
                <hr />
                <li>
                    <!-- <button @click="toggleTheme" class="theme-toggle" :aria-label="theme === 'dark' ? 'التحويل إلى الوضع الفاتح' : 'التحويل إلى الوضع الداكن'">
                        <i class="bi" :class="theme === 'dark' ? 'bi-sun-fill' : 'bi-moon-fill'"></i>
                        <span>{{ theme === 'dark' ? 'الوضع الفاتح' : 'الوضع الداكن' }}</span>
                    </button> -->
                </li>
                <li v-if="settinglist">
                    <router-link to="/AdminDashboard/ChangePassword" :aria-current="isActive('/AdminDashboard/ChangePassword') ? 'page' : null">
                        <i class="bi bi-eye-slash-fill"></i>
                        تغيير كلمة المرور
                    </router-link>
                </li>
                <li>
                    <a href="#" class="logout" @click.prevent="logout" :aria-label=" 'تسجيل الخروج'">
                        <i class="bi bi-door-open-fill"></i>
                        تسجيل الخروج
                    </a>
                </li>
            </ul>
        </section>
        <!-- CONTENT -->
        <section id="content">
            <nav>
                <button @click="menu" class="menuaction" aria-label="تبديل الشريط الجانبي">
                    <i class="bi bi-menu-button-wide"></i>
                </button>
                <a href="#" class="nav-link">نظام هساب تك ERP</a>
                <button type="button" @click="langen" class="btn btn-light" v-if="lang == 'ar'">
                    English
                </button>
                <button type="button" @click="langar" class="btn btn-light" v-if="lang == 'en'">
                    العربية
                </button>
                <a href="#" class="notification" aria-label="الإشعارات">
                    <i class="bi bi-bell-fill"></i>
                    <span class="num">0</span>
                </a>
                <div class="profile">
                    <i class="bi bi-person-bounding-box"></i>
                    {{ $store.state.name }} ({{ $store.state.cnum.cname }})
                </div>
            </nav>
            <LoadingPage v-if="loading"></LoadingPage>
            <main v-else class="router">
                <router-view :css="{ light, dark, EN, AR, dirn, xdirn, lang, color }"></router-view>
            </main>
        </section>
    </div>
</template>

<script>
import axios from "axios";
import store from "@/store";
import { mapActions } from "vuex";
import Swal from "sweetalert2";
import LoadingPage from "../components/LoadingPage.vue";

export default {
    components: { LoadingPage },
    data() {
        return {
            loading: store.state.loading,
            showside: true,
            searchQuery: "",
            menuGroups: {
                property: true,
                project: true,
                tax: true,
            },
            filteredMenu: {
                property: true,
                project: true,
                tax: true,
                ownerStatement: true,
            },
            theme: localStorage.getItem("theme") || "light",
            lang: store.state.lang || "ar",
            EN: "rtl",
            AR: "ltr",
            dir: "-230px",
            contantwi: "-60px",
            dirn: "right",
            xdirn: "left",
            user: store.state.userType,
            url: "",
            light: "#f9f9f9",
            grey: "#eee",
            dark: "#342e37",
            color: "rgba(98, 153, 174, 255)",
        };
    },
    created() {
        if (!this.user) {
            window.location.href = process.env.VUE_APP_FRONTEND_BASE_URL + "/SignIn";
        }
    },
    mounted() {
        this.url = `${store.state.imgurl}/clogo/${this.$store.state.cnum}.png`;
        this.applyTheme();
        if (window.innerWidth < 768) {
            this.showside = false;
        }
    },
    methods: {
        ...mapActions(["redirectTo"]),
        toggleGroup(group) {
            this.menuGroups[group] = !this.menuGroups[group];
        },
        isItemVisible(group) {
            return this.filteredMenu[group] || this.searchQuery === "";
        },
        filterMenu() {
            const query = this.searchQuery.toLowerCase();
            this.filteredMenu = {
                property: "إدارة أملاك".includes(query) ||
                    "العقارات".includes(query) ||
                    "سندات القبض للأملاك".includes(query),
                project: "إدارة مشاريع".includes(query) ||
                    "فواتير مشتريات مشاريع".includes(query) ||
                    "المستخلصات".includes(query) ||
                    "تقارير تكلفة المشاريع".includes(query) ||
                    "تقارير تكلفة المشاريع بالتبويب".includes(query) ||
                    "تقارير تكلفة المشاريع بالتفاصيل".includes(query),
                tax: "تقارير الضريبة".includes(query) ||
                    "تقارير الضريبة".includes(query) || // Added for /TaxReport
                    "تقارير ضريبة هيئة الزكاة".includes(query) ||
                    "ضريبة الملاك (مبيعات أو إيجارات)".includes(query) ||
                    "تقرير ضريبة شامل".includes(query),
                ownerStatement: "كشف حساب المالك".includes(query),
            };
        },
        isActive(route) {
            console.log(this.$route.path);
            return this.$route.path === route;
        },
        toggleTheme() {
            this.theme = this.theme === "light" ? "dark" : "light";
            localStorage.setItem("theme", this.theme);
            this.applyTheme();
        },
        applyTheme() {
            this.light = this.theme === "dark" ? "#1a1a1a" : "#f9f9f9";
            this.grey = this.theme === "dark" ? "#333" : "#eee";
            this.dark = this.theme === "dark" ? "#ffffff" : "#342e37";
            document.body.classList.toggle("dark-mode", this.theme === "dark");
        },
        menu() {
            this.showside = !this.showside;
        },
        async langar() {
            const change = await axios.post("/user/changelang", {
                username: this.$store.state.username,
                lang: "ar",
            });
            if (change.status === 200) {
                this.$store.state.lang = "ar";
                this.EN = "rtl";
                this.AR = "ltr";
                this.dir = "-230px";
                this.contantwi = "-60px";
                this.dirn = "right";
                this.xdirn = "left";
                this.lang = "ar";
                this.$i18n.locale = this.lang;
            }
        },
        async langen() {
            const change = await axios.post("/user/changelang", {
                username: this.$store.state.username,
                lang: "en",
            });
            if (change.status === 200) {
                this.$store.state.lang = "en";
                this.EN = "ltr";
                this.AR = "rtl";
                this.dir = "230px";
                this.contantwi = "60px";
                this.dirn = "left";
                this.xdirn = "right";
                this.lang = "en";
                this.$i18n.locale = this.lang;
            }
        },
        logout() {
            Swal.fire({
                title: "هل أنت متأكد؟",
                text: "ستتم عملية تسجيل الخروج!",
                showCancelButton: true,
                confirmButtonText: "نعم، تسجيل الخروج!",
                cancelButtonText: "لا، إلغاء!",
                reverseButtons: true,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$cookies.remove("data");
                    localStorage.clear();
                    window.location.href = `${this.$store.state.surl}/SignIn`;
                }
            });
        },
    },
};
</script>

<style scoped lang="scss">
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: "Cairo", sans-serif;
}

.page {
    direction: v-bind("EN");
}

body {
    background: v-bind("grey");
    overflow-x: hidden;
}

#sidebar {
    position: fixed;
    width: 250px;
    height: 100%;
    background: v-bind("light");
    z-index: 2000;
    transition: all 0.3s ease;
    overflow-y: auto;
    scrollbar-width: none;
}

#sidebar::-webkit-scrollbar {
    display: none;
}

#sidebar.hide {
    width: 60px;
}

#sidebar .brand {
    padding: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
}

#sidebar .brand img {
    width: 90%;
    max-height: 80px;
    object-fit: contain;
}

#sidebar .search-bar {
    padding: 10px;
    position: relative;
}

#sidebar .search-bar input {
    width: 100%;
    padding: 8px 30px 8px 10px;
    border: 1px solid v-bind("grey");
    border-radius: 20px;
    background: v-bind("light");
    color: v-bind("dark");
    font-size: 14px;
}

#sidebar .search-bar i {
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
    color: v-bind("dark");
}

#sidebar .side-menu {
    width: 100%;
    margin-top: 10px;
}

#sidebar .side-menu li {
    margin: 5px 10px;
    border-radius: 8px;
}

#sidebar .side-menu li button,
#sidebar .side-menu li a {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    padding: 0 15px;
    color: v-bind("dark");
    font-size: 14px;
    border-radius: 8px;
    transition: background 0.2s, color 0.2s;
}

#sidebar .side-menu li button i,
#sidebar .side-menu li a i {
    margin-right: 10px;
    font-size: 16px;
}

#sidebar .side-menu li.active a {
    background: v-bind("color");
    color: #ffffff;
    font-weight: 600;
}

#sidebar .side-menu li a:hover,
#sidebar .side-menu li button:hover {
    background: v-bind("grey");
    color: v-bind("color");
}

#sidebar .submenu {
    padding-left: 20px;
}

#sidebar .submenu li {
    margin: 2px 10px;
}

#sidebar.hide .side-menu li a,
#sidebar.hide .side-menu li button {
    justify-content: center;
    padding: 0;
}

#sidebar.hide .side-menu li a span,
#sidebar.hide .side-menu li button span,
#sidebar.hide .side-menu li a i.bi-chevron-right,
#sidebar.hide .side-menu li button i.bi-chevron-down {
    display: none;
}

#sidebar.hide .submenu {
    display: none;
}

#sidebar .side-menu li a.logout {
    color: #db504a;
}

#sidebar .side-menu li.theme-toggle {
    color: v-bind("dark");
}

#content {
    position: relative;
    width: calc(100% - 250px);
    left: v-bind("dir");
    transition: all 0.3s ease;
}

#sidebar.hide ~ #content {
    width: calc(100% - 60px);
    left: v-bind("contantwi");
}

#content nav {
    height: 60px;
    background: v-bind("light");
    padding: 0 20px;
    display: flex;
    align-items: center;
    gap: 15px;
    position: sticky;
    top: 0;
    z-index: 1000;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

#content nav .menuaction {
    background: none;
    border: none;
    font-size: 24px;
    color: v-bind("dark");
    cursor: pointer;
}

#content nav .nav-link {
    font-size: 16px;
    color: v-bind("dark");
}

#content nav .nav-link:hover {
    color: v-bind("color");
}

#content nav .btn {
    font-size: 14px;
    padding: 5px 10px;
}

#content nav .notification {
    position: relative;
    font-size: 20px;
    color: v-bind("dark");
}

#content nav .notification .num {
    position: absolute;
    top: -5px;
    right: -5px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #db504a;
    color: v-bind("light");
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
}

#content nav .profile {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: v-bind("dark");
}

.router {
    min-height: 90vh;
    padding: 20px;
}

@media screen and (max-width: 768px) {
    #sidebar {
        width: 200px;
    }

    #sidebar.hide {
        width: 0;
    }

    #content {
        width: 100%;
        left: 0;
    }

    #sidebar.hide ~ #content {
        width: 100%;
        left: 0;
    }

    #content nav {
        gap: 10px;
    }

    #content nav .nav-link,
    #content nav .btn,
    #content nav .profile {
        font-size: 12px;
    }
}

@media screen and (max-width: 576px) {
    #content nav .notification {
        display: none;
    }

    #content nav .btn {
        padding: 3px 6px;
    }
}

.dark-mode {
    background: #1a1a1a;
}
</style>
